import React, { useState, useEffect, useRef, useCallback } from 'react';
import './PropertySlider.css';

const slides = [
  {
    image: '/image/krishna-vatika.webp',
    project: 'Krishna Vatika',
    type: '4 BHK Premium Villas',
    location: 'Sector 16-B, Greater Noida West',
    price: 'Starting ₹57 Lac*',
    tag: 'Gated Community',
  },
  {
    image: '/image/loutusgreenvilla.png',
    project: 'Lotus Greens Villa 2',
    type: '3 & 4 BHK Smart Villas',
    location: 'Vaidpura, Greater Noida West',
    price: 'Starting ₹65 Lac*',
    tag: 'Hot Price',
  },
  {
    image: '/image/ShrishtiHeights.webp',
    project: 'Aalayam Srishti Villas',
    type: '2 & 3 BHK Premium Villas',
    location: 'Sec 16, Chipyana Bujurg, Greater Noida West',
    price: 'Starting ₹45 Lac*',
    tag: 'Commercial Club',
  },
  {
    image: '/image/bollywoodaerocity.jpeg',
    project: 'Bollywood Aero City Farms',
    type: 'Luxury Farm Estates',
    location: 'Village Sarakpur, Near Jewar Airport, Yamuna Expressway',
    price: '₹20,000 / Sq. Yd.',
    tag: 'High ROI Investment',
  },
  {
    image: '/image/Greenparadise.jpg',
    project: 'Paradise Greens Plaza',
    type: 'Studio Apartments & Retail Shops',
    location: 'Sector 16B, Near 1 Murti Chowk, Noida Extension',
    price: 'Starting ₹23.09 Lac*',
    tag: 'Ready to Move',
  },
  {
    image: '/image/GV1.jpg',
    project: 'Green Villa 2',
    type: 'Independent Villas & Plots',
    location: 'Sector 16-B, Greater Noida West',
    price: 'Best Price',
    tag: 'Prime Location',
  },
  {
    image: '/siteimage/WhatsApp Image 2026-06-30 at 12.17.23.jpeg',
    project: 'Site View',
    type: 'On-Ground Property View',
    location: 'Greater Noida West',
    price: '',
    tag: 'Site Visit',
  },
  {
    image: '/siteimage/WhatsApp Image 2026-06-30 at 12.17.23 (2).jpeg',
    project: 'Site View',
    type: 'On-Ground Property View',
    location: 'Greater Noida West',
    price: '',
    tag: 'Site Visit',
  },
  {
    image: '/siteimage/WhatsApp Image 2026-06-30 at 12.17.23 (3).jpeg',
    project: 'Site View',
    type: 'On-Ground Property View',
    location: 'Greater Noida West',
    price: '',
    tag: 'Site Visit',
  },
  {
    image: '/siteimage/WhatsApp Image 2026-07-15 at 13.23.39.jpeg',
    project: 'Latest Update',
    type: 'On-Site Progress',
    location: 'Greater Noida West',
    price: '',
    tag: 'New Update',
  },
  {
    image: '/siteimage/WhatsApp Image 2026-07-15 at 13.23.39 (1).jpeg',
    project: 'Latest Update',
    type: 'On-Site Progress',
    location: 'Greater Noida West',
    price: '',
    tag: 'New Update',
  },
];

const VISIBLE = 4;     // cards visible at a time
const AUTO_MS = 2800;  // auto-advance every 2.8s

export default function PropertySlider() {
  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(false);
  const [dragging, setDragging] = useState(false);
  const dragStart = useRef(0);
  const timerRef = useRef(null);

  const total = slides.length;
  const maxIndex = total - VISIBLE;

  const next = useCallback(() => {
    setCurrent(c => (c >= maxIndex ? 0 : c + 1));
  }, [maxIndex]);

  const prev = useCallback(() => {
    setCurrent(c => (c <= 0 ? maxIndex : c - 1));
  }, [maxIndex]);

  /* Auto train */
  useEffect(() => {
    if (paused) return;
    timerRef.current = setInterval(next, AUTO_MS);
    return () => clearInterval(timerRef.current);
  }, [paused, next]);

  /* Drag / touch support */
  const onPointerDown = (e) => {
    setDragging(true);
    setPaused(true);
    dragStart.current = e.clientX ?? e.touches?.[0]?.clientX ?? 0;
  };
  const onPointerUp = (e) => {
    if (!dragging) return;
    const end = e.clientX ?? e.changedTouches?.[0]?.clientX ?? 0;
    const diff = dragStart.current - end;
    if (diff > 40) next();
    else if (diff < -40) prev();
    setDragging(false);
    // resume after 3s
    setTimeout(() => setPaused(false), 3000);
  };

  /* Dot click */
  const goTo = (idx) => {
    setCurrent(Math.min(idx, maxIndex));
    setPaused(true);
    setTimeout(() => setPaused(false), 3000);
  };

  const offset = -(current * (100 / VISIBLE));

  return (
    <section className="ps-section">
      {/* Header */}
      <div className="ps-header">
        <div className="ps-label">OUR PROJECTS</div>
        <h2 className="ps-title">Explore Our <span>Properties</span></h2>
        <p className="ps-sub">A journey through our finest real estate developments across Greater Noida West</p>
      </div>

      {/* Track wrapper */}
      <div
        className="ps-viewport"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => { if (!dragging) setPaused(false); }}
        onMouseDown={onPointerDown}
        onMouseUp={onPointerUp}
        onTouchStart={onPointerDown}
        onTouchEnd={onPointerUp}
      >
        {/* Prev Arrow */}
        <button
          className="ps-arrow ps-arrow-left"
          onClick={() => { prev(); setPaused(true); setTimeout(() => setPaused(false), 3000); }}
          aria-label="Previous"
        >
          <i className="fa fa-chevron-left" />
        </button>

        {/* Slide track */}
        <div className="ps-track-wrap">
          <div
            className="ps-track"
            style={{ transform: `translateX(${offset}%)`, transition: dragging ? 'none' : 'transform 0.55s cubic-bezier(0.25,0.8,0.25,1)' }}
          >
            {slides.map((s, i) => (
              <div className="ps-card" key={i}>
                <div className="ps-card-img-wrap">
                  <img src={s.image} alt={s.project} draggable={false} />
                  <div className="ps-card-overlay" />
                  {s.tag && <span className="ps-card-tag">{s.tag}</span>}
                </div>
                <div className="ps-card-body">
                  <div className="ps-card-type">{s.type}</div>
                  <div className="ps-card-name">{s.project}</div>
                  <div className="ps-card-loc">
                    <i className="fa fa-location-dot" /> {s.location}
                  </div>
                  {s.price && <div className="ps-card-price">{s.price}</div>}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Next Arrow */}
        <button
          className="ps-arrow ps-arrow-right"
          onClick={() => { next(); setPaused(true); setTimeout(() => setPaused(false), 3000); }}
          aria-label="Next"
        >
          <i className="fa fa-chevron-right" />
        </button>
      </div>

      {/* Dots */}
      <div className="ps-dots">
        {Array.from({ length: maxIndex + 1 }).map((_, i) => (
          <button
            key={i}
            className={`ps-dot ${current === i ? 'active' : ''}`}
            onClick={() => goTo(i)}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>

      {/* Progress bar */}
      <div className="ps-progress-bar">
        <div
          className="ps-progress-fill"
          style={{
            width: `${((current + VISIBLE) / total) * 100}%`,
            transition: paused ? 'none' : `width ${AUTO_MS}ms linear`,
          }}
        />
      </div>
    </section>
  );
}
